import { getConversationsListAPI } from 'widget/api/conversation';

export default (status) => {
  const state = {
    conversations: {},
    conversationCount: 0,
    uiFlags: {
      allConversationsLoaded: false,
      isFetchingList: false,
    },
  };

  const getters = {
    getConversations: $state => {
      const data = Object.values($state.conversations).reverse();

      return data;
    },
    getUIFlags: $state => $state.uiFlags,
    getIsFetchingList: $state => {
      return $state.uiFlags.isFetchingList
    },
    allConversationsLoaded: $state => $state.uiFlags.allConversationsLoaded,
    getEarliestConversation: $state => {
      const conversations = Object.values($state.conversations);

      if (conversations.length) {
        return conversations[0];
      }

      return {};
    },
    getConversationCount: $state => $state.conversationCount,
  };

  const actions = {
    addConversationsToList: ({ commit }, payload) => {
      commit('addConversationsToList', payload);
    },
    setConversationListLoading: ({ commit }, payload) => {
      commit('setConversationListLoading', payload);
    },
    fetchOldConversations: async ({ commit }, { before } = {}) => {
      try {
        commit('setConversationListLoading', true);

        const {
          data: { payload, meta },
        } = await getConversationsListAPI({ before, filter: {
          status
        } });

        if (meta.total_count != null) {
          commit('setConversationCount', meta.total_count);
        }

        commit('addConversationsToList', payload);

        commit('setConversationListLoading', false);
      } catch (error) {
        commit('setConversationListLoading', false);
      }
    },
    addOneConversationToList: ({ commit }, payload) => {
      commit('addConversationsToList', [payload]);

      commit('setConversationCount', state.conversationCount + 1);
    },
  };

  const mutations = {
    addConversationsToList($state, payload) {
      if (!payload?.length) {
        $state.uiFlags = {
          ...$state.uiFlags,
          allConversationsLoaded: true,
        };
        return;
      }

      $state.conversations = {
        ...$state.conversations,
        ...payload.reduce((acc, conversation) => {
          acc[conversation.friendly_id] = conversation;

          return acc;
        }, {})
      };

      if (Object.keys($state.conversations).length >= $state.conversationCount) {
        $state.uiFlags = {
          ...$state.uiFlags,
          allConversationsLoaded: true,
        };
      }
    },
    setConversationCount($state, count) {
      $state.conversationCount = count;
    },
    setConversationListLoading($state, status) {
      $state.uiFlags = {
        ...$state.uiFlags,
        isFetchingList: status,
      };
    },
  };

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
};
